import * as React from 'react'
import { Box, Typography, Divider } from '@mui/material'

import Tooltip from 'components/Shared/Tooltip'
import { formatNumbers } from 'lib/Helper'
import variables from 'assets/styles/scss/shared/_variables.module.scss'

type Props = {
  label: string
  value: number | string
  info: any
  showDivider?: boolean
} & typeof defaultProps

const defaultProps = {
  info: '',
  showDivider: false,
}

const KeyMetric = (props: Props) => {
  const { label = '', value = '', info = '', showDivider = false } = props || {}

  return (
    <Box>
      <Typography variant="body1">
        {label}{' '}
        <Tooltip
          info={<span dangerouslySetInnerHTML={{ __html: info }}></span>}
        />
      </Typography>
      <Typography variant="h4" color={variables['grey-22']}>
        {formatNumbers(value)}
      </Typography>
      {showDivider && <Divider sx={{ margin: '1rem 0 1rem 0' }} />}
    </Box>
  )
}

export default KeyMetric
